export const CATALOG_SORTS = ['featured', 'priceAsc', 'priceDesc', 'nameAsc'] as const
export type CatalogSort = typeof CATALOG_SORTS[number]

export const parseCatalogSort = (value?: string | null): CatalogSort => {
    if (value === 'priceAsc' || value === 'priceDesc' || value === 'nameAsc') {
        return value
    }
    return 'featured'
}

export const getMinOrderQty = (value?: number | null) => {
    const qty = Number(value)
    return Number.isInteger(qty) && qty > 1 ? qty : 1
}

type SortableCatalogItem = {
    names?: { language: string; name: string }[]
    likeCount?: number
    featured?: boolean
}

export const sortCatalogItems = <T extends SortableCatalogItem>(
    items: T[],
    sort: CatalogSort,
    getPrice: (item: T) => number,
    language?: string
): T[] => {
    const copy = [...items]
    const getName = (item: T) => {
        const names = item.names || []
        const name = language && names.length > 1
            ? names.find(n => n.language === language)?.name || names[0]?.name
            : names[0]?.name
        return (name || '').toLocaleLowerCase()
    }

    copy.sort((left, right) => {
        const nameCmp = getName(left).localeCompare(getName(right), undefined, { sensitivity: 'base' })

        if (sort === 'priceAsc' || sort === 'priceDesc') {
            const diff = getPrice(left) - getPrice(right)
            if (diff !== 0) {
                return sort === 'priceAsc' ? diff : -diff
            }
            return nameCmp
        }

        if (sort === 'nameAsc') {
            return nameCmp
        }

        const featuredLeft = left.featured ? 1 : 0
        const featuredRight = right.featured ? 1 : 0
        if (featuredRight !== featuredLeft) {
            return featuredRight - featuredLeft
        }

        const likeDiff = (right.likeCount ?? 0) - (left.likeCount ?? 0)
        return likeDiff !== 0 ? likeDiff : nameCmp
    })

    return copy
}
